export const companyCategory = [
  'Pertanian, perikanan & peternakan',
  'Kecantikan, farmasi',
  'Bahan bangunan',
  'Konstruksi & desain interior',
  'Jasa pengiriman, kurir',
  'Dropshipper',
  'Elektronik, komputer',
  'Fashion, aksesoris',
  'Makanan, minuman',
  'Furnitur',
  'Oleh-Oleh',
  'Salon, spa, pusat kebugaran',
  'Kerajinan tangan',
  'Hotel dan penginapan',
  'Keperluan rumah tangga',
  'Jasa laundry',
  'alat medis, sport, musik',
  'Jasa fotografi',
  'Tanaman, hewan peliharaan',
  'Percetakan, ATK',
  'Restoran, cafe',
  'Pariwisata dan travel',
  'Mainan',
  'Bengkel, sparepart',
  'Lainnya'
]

export const companyTotalEmployee = [
  '1 - 50',
  '51 - 100',
  '101 - 250',
  '251 - 500',
  '501 - 1000',
  '+1000'
]

export const companyCategoryCredilinq = [
  'Agriculture / Fishing / Food Production',
  'Building and Construction - Private Sector',
  'Building and Construction - Public Sector',
  'Education',
  'Energy - generation and distribution',
  'Health & Human Services',
  'IT services',
  'Manufacturing',
  'Manufacturing - computer & electronics',
  'Media',
  'Other',
  'Renewable',
  'Retail Trading',
  'Service Sector - F&B',
  'Service Sector - non-F&B',
  'Transport & Logistics',
  'Wholesale Trader'
]

export const companyIndustry = [
  {
    value: 'Agriculture / Fishing / Food Production',
    label: 'Pertanian / Perikanan / Produksi Pangan'
  },
  {
    value: 'Building and Construction - Private Sector',
    label: 'Bangunan dan Konstruksi - Sektor Swasta'
  },
  {
    value: 'Building and Construction - Public Sector',
    label: 'Bangunan dan Konstruksi - Sektor Publik'
  },
  {
    value: 'Education',
    label: 'Pendidikan'
  },
  {
    value: 'Energy - generation and distribution',
    label: 'Energi - pembangkitan dan distribusi'
  },
  {
    value: 'Health & Human Services',
    label: 'Kesehatan & Layanan Kemanusiaan'
  },
  {
    value: 'IT services',
    label: 'Layanan TI'
  },
  {
    value: 'Manufacturing',
    label: 'Manufaktur'
  },
  {
    value: 'Manufacturing - computer & electronics',
    label: 'Manufaktur - komputer & elektronik'
  },
  {
    value: 'Manufacturing - consumer related',
    label: 'Manufaktur - terkait konsumen'
  },
  {
    value: 'Media',
    label: 'Media'
  },
  {
    value: 'Other',
    label: 'Lainnya'
  },
  {
    value: 'Renewable',
    label: 'Terbarukan'
  },
  {
    value: 'Retail Trading',
    label: 'Perdagangan Eceran'
  },
  {
    value: 'Service Sector - F&B',
    label: 'Sektor Jasa - F&B'
  },
  {
    value: 'Service Sector - non-F&B',
    label: 'Sektor Jasa - non-F&B'
  },
  {
    value: 'Transport & Logistics',
    label: 'Transportasi & Logistik'
  },
  {
    value: 'Wholesale Trader',
    label: 'Pedagang Grosir'
  }
]
